import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import * as moment from 'moment';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { MerchantTransactionSearch } from 'src/app/models/merchant-transactions';
import { countries } from 'src/app/utilities/countries';
import { appCodeValue, emptyFields, gstColumnName, InstanceName, ReportTerminals, SettlementDocumentStatus, settlementDocumentStatusOptions,
textForSettlementDocumentStatus, UsersType } from 'src/app/utilities/common-file';
import { SettlementService } from '../settlements.service';
import { MerchantSearch } from 'src/app/models/merchant';
import { DownloadService } from 'src/app/reports/download-service';
import { ViewSettlementDetailsComponent } from '../../view-details/view-settlement-details.component';
import { DateRange, MomentHelper } from '../../models/date';
import { LocationSearch } from '../../models/locations';
import { Messages } from '../../utilities/message';
import { CommonService } from '../../utilities/common-service';
import { ViewSettledTransactionsComponent } from '../../view-details/view-settled-transactions.component';
import { Config } from 'src/environments/config';

@Component({
  selector: 'app-settlement-documents',
  templateUrl: './settlement-documents.component.html'
})
export class SettlementDocumentsComponent implements OnInit {
  selectedData: any;
  merchantId: any;
  locationId: any;
  loginUserType = '';
  userType = UsersType;
  loading = false;
  settlementName: string;
  countries = countries;
  settlementStatus = SettlementDocumentStatus;
  textForDocumentStatus = textForSettlementDocumentStatus;
  documentStatusOptions = settlementDocumentStatusOptions;
  merchantCurrency: any;
  emptyField = emptyFields;
  downloadList = [];
  selectedRateDateRange: Date[] = null;
  showDownload: string;
  totalAmount=0;
  currencySymbol='';
  totalBankFee=0; 
  totalTransactionFee=0 
  totalNetAmount=0;
  totalCommission=0;
  totalGST =0;
  grandTotal=0;
  totalFlexmGst:any
  totalFlexmFee:any;
  gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
  gstColumnName = gstColumnName;
  columnName :any;
  // tslint:disable-next-line: max-line-length
  private tableData: NzTableData<
    MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>(
    new MerchantTransactionSearch(), 'transactionStatus');
    private tableDataForMerchants: NzTableData<
    MerchantSearch, any> = new NzTableData<MerchantSearch, any>(
    new MerchantSearch(), 'transactionStatus');
    private tableDataForLocations: NzTableData<LocationSearch, any> = new NzTableData<LocationSearch, any>
    (new LocationSearch(), 'fullName');
  // tslint:disable-next-line: max-line-length
  constructor(
    private fb: UntypedFormBuilder,
    private commonService: CommonService,
    private authService: AuthService,
    private router: Router,
    private modalService: NzModalService,
    private notification: NzNotificationService,
    private settlementService: SettlementService,
    private drawerService: NzDrawerService,
    private downloadService: DownloadService
  ) {

  }
  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.merchantId = this.authService.getMerchantId();
    this.locationId = this.authService.getLocationId();
    this.loginUserType = this.authService.getRole();
    this.getMerchant();
    if (this.loginUserType === this.userType.locationUser || this.loginUserType === this.userType.locationManager) {
      if (this.locationId) {
        this.tableData.search.locationId = this.locationId;
      } else {

      }
    }
    this.getSettlementDocuments();
  }
  getMerchant() {
    this.tableDataForMerchants.data[0] = this.authService.getMerchantDetails();
    this.merchantCurrency = this.tableDataForMerchants.data[0].currency;
    this.getLocations();
}
  getLocations() {
  this.tableDataForLocations.data = this.authService.getLocationDetails();
  }
  getSettlementDocuments(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    // tslint:disable-next-line: radix
    this.settlementService.getSettlementDocumentsWithLimit(this.tableData).subscribe(
      (response: any) => {
         this.totalTransactionFee=response.data.totalTransactionFee.toFixed(2);
        this.totalNetAmount=response.data.totalNetAmount.toFixed(2);
        this.totalBankFee=response.data.totalBankFee.toFixed(2);
        this.totalAmount=response.data.totalAmount.toFixed(2);
        this.grandTotal=response.data.grandTotal.toFixed(2);
        this.totalCommission=response.data.totalCommission.toFixed(2);
        this.totalGST=response.data.totalGst.toFixed(2);
        this.totalFlexmGst = response.data.totalFlexmGst.toFixed(2);
        this.totalFlexmFee = response.data.totalFlexmFee.toFixed(2);
        this.loading = false;
        this.tableData.total = response.data.total;
        this.tableData.data = response.data.transactions;
        this.showDownload = Messages.downloadReport;       
        this.currencySymbol = this.commonService.getCurrencySymbol(this.authService.getAppCode() === appCodeValue.all? '': this.authService.getAppCode());
      },
      (err) => {
        this.loading = false;
        this.tableData.data = [];
      }
    );

  }
  onUpdatedOnChange(range: any[]) {
    if (range.length <= 1) {
      return;
    }
    this.tableData.search.createdDate = MomentHelper.createDateRange(range);
    this.getSettlementDocuments();
  }
  updateClear(range: any[]) {
    if (range.length <= 1) {
      this.tableData.search.createdDate = DateRange.empty();
      return;
  }
  }
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.getSettlementDocuments(false);
  }
  getSettlementDocumentStatus(status) {
    return this.commonService.getSettlementDocumentStatus(status);
  }
  getColorForSettlementDocumentStatus(status) {
    return this.commonService.getColorForSettlementDocumentStatus(status);
  }
  getCurrency(currency) {
    const index = this.countries.findIndex((M) => M.currency_code === currency);
    if (index !== -1) {
      return this.countries[index].currency_symbol;
    }
  }
  repostConfirmation(data) {
    this.modalService.confirm({
      nzTitle: 'Are you sure repost this transaction?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.repostTransaction(data),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  repostTransaction(data) {
 
      const dataForRepost = {
        id: data.id
      };
      this.settlementService.repost(dataForRepost).subscribe((response: any) => {
        this.notification.success(response.message, '', {nzKey: 'key'});
        this.getSettlementDocuments();
      }, err => {
  
      });
  }

  viewDetails(data) {
    this.selectedData = data;
    const drawerRefCreate = this.drawerService.create<ViewSettlementDetailsComponent, { value: any, reportType: any }, string>({
      nzContent: ViewSettlementDetailsComponent,
      nzWidth: '900px',
      nzClosable: true,
      nzContentParams: {
        value: this.selectedData,
        reportType: 'list'
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    // tslint:disable-next-line: no-shadowed-variable
    drawerRefCreate.afterClose.subscribe((data) => {
     if (data && typeof data !== null) {
       this.getSettlementDocuments();
     }
    });
  }
  downloadReport() {
    if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
      this.notification.info('Download Processing', 'Please Wait', {
        nzKey : 'key'
      });
      const value = {
        merchantId: this.authService.getMerchantId(),
        locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
        startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
        endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
        status: this.tableData.search.status,
        settlementStatus: this.tableData.search.settlementStatus
    };
      const filterHeaders = ['Created On', 'Location Name', 'Status'];
      const filterData = [this.tableData.search.createdDate ? moment(this.tableData.search.createdDate.startDate)
      .local().format('DD-MMM-YYYY') + ' to ' + moment(this.tableData.search.createdDate.endDate).local().format('DD-MMM-YYYY') : '',
      this.tableData.search.locationId ? this.tableDataForLocations.data.find(x => x.id === this.tableData.search.locationId).name : 'All',
      this.tableData.search.settlementStatus === '' ? 'All' : this.tableData.search.settlementStatus ? 'Paid' : 'Open'
    ];
    var gridFooter;
    var footerData;
   // For Footer 
   if(this.gst){
    gridFooter = ['Total Amount','Total TransactionFee','Total Commission','Total GST','Grand Commission Total','Total BankFee','Total '+this.columnName,'Total FlexM Fee','Total Net Amount'];      
    footerData=[
    this.currencySymbol+this.totalAmount,
    this.currencySymbol+this.totalTransactionFee,
    this.currencySymbol+this.totalCommission,
    this.currencySymbol+this.totalGST,
    this.currencySymbol+this.grandTotal,
    this.currencySymbol+this.totalBankFee,
    this.currencySymbol+this.totalFlexmGst,
    this.currencySymbol+this.totalFlexmFee,
    this.currencySymbol+this.totalNetAmount
    ];
   }else{
    gridFooter = ['Total Amount','Total TransactionFee','Total Commission','Total GST','Grand Commission Total','Total BankFee','Total Net Amount'];      
    footerData=[
    this.currencySymbol+this.totalAmount,
    this.currencySymbol+this.totalTransactionFee,
    this.currencySymbol+this.totalCommission,
    this.currencySymbol+this.totalGST,
    this.currencySymbol+this.grandTotal,
    this.currencySymbol+this.totalBankFee,
      this.currencySymbol+this.totalNetAmount
    ];
   }
      this.settlementService.downloadReportForMerchantSettlement(value).subscribe((response: any) => {
      this.tableData.total = response.data.total;
      this.downloadList = response.data.transactions;
      if (this.downloadList.length > 0) {
        var headers;
        if(this.gst){
           headers = ['ID','Document No','Merchant', 'Location', 'Status' , 'User Type', 'Settlement Amount', 'Transaction Fee',this.columnName,'Total FlexM Fee','Commission','GST','Total Commission','Bank Fee', 'Net Amount Transferred', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];
        }else{
          headers = ['ID','Document No','Merchant', 'Location', 'Status' , 'User Type', 'Settlement Amount','Total FlexM Fee','Commission','GST','Total Commission','Bank Fee', 'Net Amount Transferred', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];
        }
        // tslint:disable-next-line: max-line-length
        // tslint:disable-next-line: max-line-length
        this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantSettlementReport, this.tableData.search.createdDate.startDate, this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantSettlementReport, ReportTerminals.merchantSettlementReport, filterHeaders, filterData,gridFooter,footerData);
      }
    });
  } else {
    this.notification.error(Messages.noDateSelected, '', {
      nzKey : 'key'
    });
  }
  }
 // View Transactions
viewTransactions(data) {
  this.selectedData = data;
  const drawerReceipt = this.drawerService.create<ViewSettledTransactionsComponent, { selectedTransaction: any}, string>({
    nzContent: ViewSettledTransactionsComponent,
    nzWidth: '850px',
    nzClosable: true,
    nzContentParams: {
      selectedTransaction: this.selectedData,
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      padding: '0'
    }
  });
  // tslint:disable-next-line: no-shadowed-variable
  drawerReceipt.afterClose.subscribe((data) => {
    if (data && typeof data !== null) {
    }
   });
}
  showTransactions() {
    this.router.navigate(['/settlements/transactions']);
  }
  // SettlementBy
getSettlementBy(mode) {
  return this.commonService.getSettlementBy(mode);
}
// SettlementByColor
getColorForSettlementBy(mode) {
  return this.commonService.getColorForSettlementBy(mode);
}
// Get tag Text for the Users Type
getUsersType(type) {
  return this.commonService.getUsersType(type);
}
// Get tag color for the Users Type
getUsersTypeColor(type) {
  return this.commonService.getUsersTypeColor(type);
}
}
